<template>
    <div class="product-footer-container" v-bind:class="{'show': showBottomBar}">
<!--        <div class="product-footer-top" v-bind:class="{'show': showTopBar}">-->
<!--            <div class="close-button">-->
<!--                <a href="#" @click.prevent="closeTopBar()">-->
<!--                    <img src="/images/icon-close.svg" />-->
<!--                </a>-->
<!--            </div>-->
<!--            <div class="container">-->
<!--                <div class="columns is-variable is-8">-->
<!--                    <div class="column first-step">-->
<!--                        <h5 class="column-heading hyper5 bold">{{$t('web.travel-sim.first-step')}}</h5>-->
<!--                        <hr class="line">-->
<!--                        <div class="first-step-container">-->
<!--                            <div class="image-container">-->
<!--                                <a href="https://itunes.apple.com/hk/app/hyperair-%E5%94%B1%E9%8C%A2%E7%A5%9E%E5%99%A8-%E5%A4%96%E5%B9%A3%E9%A0%90%E8%A8%82-%E6%97%85%E9%81%8Asim%E5%8D%A1/id1397364347?mt=8" target="blank">-->
<!--                                    <img class="app-store-image" src="/images/AppStore.svg" />-->
<!--                                </a>-->
<!--                                <a href="https://play.google.com/store/apps/details?id=com.hyperair.app" target="blank">-->
<!--                                    <img class="app-store-image" src="/images/PlayStore.svg" />-->
<!--                                </a>-->
<!--                            </div>-->
<!--                            <div class="search-container">-->
<!--                                <div class="hyper4 black">{{$t('web.download-app-banner.download-now')}}</div>-->
<!--                                <div class="search hyper6 navy-blue bold"><i class="far fa-search"></i>{{$t('web.download-app-banner.hyperair')}}</div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="column second-step">-->
<!--                        <h5 class="column-heading hyper5 bold">{{$t('web.travel-sim.second-step')}}</h5>-->
<!--                        <hr class="line">-->
<!--                        <div class="qr-container">-->
<!--                            <div class="qr-code">-->
<!--                                <qr-code-->
<!--                                        :text="qrLink"-->
<!--                                        :size="150"-->
<!--                                        color="#3155A6"-->
<!--                                        bg-color="#FFF"-->
<!--                                        error-level="L">-->
<!--                                </qr-code>-->
<!--                            </div>-->
<!--                            <div class="scan-qr-code hyper4 black">{{$t('web.travel-sim.scan-product-qr-code')}}</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="product-footer-bottom">
            <div class="container">
                <div class="product-footer-price-container">
                    <div class="price hyper3 brand-blue">{{ currencyPrefix }}{{ price.toLocaleString() }}</div>
                    <div class="price-original">
                        <del>{{ currencyPrefix }}{{ priceOriginal.toLocaleString() }}</del>
                        <span class="price-guarantee palette-coral">
                            {{ $t('web.travel-sim.lowest-price-guarantee') }}
                        </span>
                    </div>
                </div>
                <div class="product-footer-book-container">
                    <a v-if="inventory > 0" :href="bookNowRoute" class="button is-block is-primary is-large hyper6 bold">
                        {{ $t('web.travel-sim.book-now') }}
                    </a>
                    <a v-else href="#" class="button is-block is-primary is-large hyper6 bold" disabled="">
                        {{ $t('web.travel-sim.no-stock') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isMobile, isAndroid, isIOS } from 'mobile-device-detect';
    import { redirectToAppstore } from '../helper';
    export default {
        props: {
            currencyPrefix: String,
            price: Number,
            priceOriginal: Number,
            bookNowRoute: String,
            inventory: Number
        },

        data(){
            return {
                showBottomBar: false,
                showTopBar: false,
                qrLink: ""
            }
        },

        computed: {
            showOverlay(){
                return isMobile
            }
        },

        methods: {
            onScroll(){
                if(window.scrollY >= 831){
                    this.showBottomBar = true;
                }else{
                    this.showBottomBar = false;
                }
            },

            openTopBar(){
                if(isAndroid || isIOS){
                    redirectToAppstore();
                }else {
                    this.showTopBar = true;
                }
            },

            closeTopBar(){
                this.showTopBar = false;
            }
        },

        mounted() {
            window.addEventListener('scroll', this.onScroll);
            setTimeout(() => {
                this.onScroll;
            }, 100);
            this.qrLink = window.location.href + "?redirect_to_appstore=true";

            this.$events.$on('product-bottom-bar:showTopBar', () => {
                this.openTopBar();
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .product-footer-container{
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 2;
        transition: transform 0.5s;
        transform: translate(0, 100%);

        &.show{
            transform: translate(0, 0px);
        }

        .product-footer-top{
            background-color: #F7F7F7;
            padding: 16px 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            transition: transform 0.5s;

            .close-button{
                position: absolute;
                top: 0;
                right: 0;
                padding: 8px;
            }

            &.show{
                transform: translate(0, -100%);
            }
            
            .column-heading{
                margin-bottom: 8px;
            }
            hr{
                background: #DEDEDE;
            }
            .first-step{
                margin-right:15%;
            }
            .first-step-container{
                display:flex;
            
            
                .image-container{

                }
                .search-container{
                    display:flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:100%;
                    .search{
                    border-radius: 10px;
                    background: #FFFFFF;
                    padding: 3% 0;
                    padding-left:8%;
                    margin-bottom:3%;
                    .far{
                        margin-right:5%;
                    }
                    }
                }
            }

            p{
                margin-bottom: 16px;
            }

            .app-store-image{
                max-width: 134px;
            }

            .qr-container{
                display:flex;
                text-align: center;

                .qr-code{
                    padding: 8px;
                    border-radius: 10px;
                    background: #FFF;
                    display: inline-block;
                }
                .scan-qr-code{
                    text-align: left;
                    margin-left:5%;
                }
            }
        }

        .product-footer-bottom{
            background: #FFF;
            box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.1);
            position: relative;
            z-index: 2;
        }

        .container{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 0;
            @include responsive(){
                display: block;
                padding: 16px 0;
            }
        }

        .product-footer-price-container{
            @include responsive(){
                display: flex;
                align-items: baseline;
                position: relative;
                margin-bottom: 1rem;
            }
            .price{
                line-height: 1;
            }

            .price-original{
                @include responsive(){
                    margin-left: 8px;
                }
            }

            .price-guarantee{
                display: inline-block;
                margin-left: 8px;
                @include responsive(){
                    position: absolute;
                    right: 0;
                    top: 16px;
                }
            }
        }

        .product-footer-book-container{
            .button{
                width: 200px;
                @include responsive(){
                    width: 100%;
                }
            }
        }
    }
</style>
